import { type BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react'
import { type ClassificationRequestData, type ClassificationResultData } from '../../types'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { createAxiosInstance } from '../common'

export const apiClassificationBaseQuery =
  (): BaseQueryFn<
  {
    url: string
    method: AxiosRequestConfig['method']
    data?: AxiosRequestConfig['data']
    params?: AxiosRequestConfig['params']
    headers?: AxiosRequestConfig['headers']
  },
  unknown,
  unknown
  > =>
    async ({ url, method, data, params, headers }) => {
      const api = createAxiosInstance(`${String(process.env.REACT_APP_ENGINE_API_URL)}`)
      try {
        const result = await api(url, {
          method,
          data,
          params,
          headers
        })
        return { data: result.data }
      } catch (axiosError) {
        console.dir(axiosError)

        const err = axiosError as AxiosError

        throw err
      }
    }

export const classificationApi = createApi({
  reducerPath: 'classificationApi',
  baseQuery: apiClassificationBaseQuery(),
  endpoints: (builder) => ({
    getClassificationResult: builder.mutation<ClassificationResultData, { data: ClassificationRequestData }>({
      query ({ data }) {
        return {
          url: '/classifier',
          method: 'post',
          data,
          prepareHeaders: (headers: any) => {
            headers.set('Content-Type', 'application/json')
            return headers
          },
          responseHandler: async (response: Response) => await response.json()
        }
      }
    })
  })
})

export const { useGetClassificationResultMutation } = classificationApi
